import React from 'react';
import { ContentPage } from 'modules2/content-page';
import { FiveStarCard } from './components';

const FiveStar = () => {
    return (
        <ContentPage
            header={{
                title: 'Five Star',
                description: '',
                controls: '',
            }}
            body={<FiveStarCard />}
        />
    );
};

export default FiveStar;
